import styled, { css } from "styled-components";

export const StyledTypography = styled.p`
  ${({ font }) => font && css(font)};
  ${({ color }) => color && css`
    color: ${color};
  `};
  text-align: ${({ align }) => align};
  ${({ customStyle }) => customStyle && customStyle};
  strong, b {
    font-weight: 700;
  }
`;
